import React, { useRef, useState, useEffect } from "react";
import CustomPortal from "./CustomPortal";
import { ChevronDown } from "lucide-react";

export default function PortalDropdown({
  value = "",
  options = [],
  onChange,
  fieldName = "",
  // placeholder = "Select option",
}) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });

  const toggleDropdown = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    
    if (!open) {
      // Open dropdown
      const rect = ref.current.getBoundingClientRect();
      setPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width < 140 ? 140 : rect.width,
      });
    }
    
    setOpen(!open); // Toggle the state
  };

  const closeDropdown = () => setOpen(false);

  const selectedLabel =
    options.find((o) => o.value == value)?.label ?? "";

  // outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (!open) return;
      if (ref.current && ref.current.contains(e.target)) return;
      const dd = document.getElementById("portal-dropdown");
      if (dd && dd.contains(e.target)) return;
      setOpen(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <>
      {/* Trigger Box */}
      <div
        ref={ref}
        onClick={toggleDropdown} // Changed from openDropdown to toggleDropdown
        style={{
          width: "100%",
          minWidth: "140px",
          height: "45px",
          border: "1px solid #666",
          borderRadius: "8px",
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          background: "#FFF",
        }}
      >
        <span style={{ color: value ? "#333" : "#999", fontFamily: "Montserrat", fontSize: "14px", fontStyle: 'normal', fontWeight: '400' }}>
          {selectedLabel}
        </span>

        <ChevronDown
          size={16}
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "0.2s",
          }}
        />
      </div>

      {/* Portal Dropdown */}
      {open && (
        <CustomPortal>
          <div
            id="portal-dropdown"
            style={{
              position: "absolute",
              top: pos.top,
              left: pos.left,
              width: pos.width,
              minWidth: "140px",
              maxWidth: "100%",
              background: "#FFF",
              borderRadius: "8px",
              maxHeight: "260px",
              overflowY: "auto",
              zIndex: 99999,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            {options.length === 0 && (
              <div
                style={{
                  padding: "12px",
                  color: "#888",
                  textAlign: "center",
                }}
              >
                No options
              </div>
            )}

            {options.map((opt) => (
              <div
                key={opt.value}
                onClick={() => {
                  onChange(opt.value);
                  closeDropdown();
                }}
                style={{
                  padding: "10px 15px",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#FFFEF0")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
                className={fieldName}
              >
                {(opt.value == 'yes' || opt.value == 'no' || fieldName == 'variation_option') ? <span className={"option-" + opt.value + " option_" + fieldName}>{opt.label}</span> : opt.label}
              </div>
            ))}
          </div>
        </CustomPortal>
      )}
    </>
  );
}